export { default } from './createCookieConsent';
